import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import { mapDispatchToProps } from 'component/page/search/InCitySearchFilterContent/InCitySearchFilterContent.selectors';
import { StringFormatter } from '@agoda/react-handyman';
import { getKeywordQueryParams } from 'gql/service/graph/activityService';
import Feature from 'component/common/Experiment/Feature';
import { FeatureName } from 'core/constant/FeatureName';
import InCitySearchFilterContent from 'component/page/search/InCitySearchFilterContent/InCitySearchFilterContent';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { NavigationState } from 'store/slice';
import { createSelector } from '@reduxjs/toolkit';
import { selectNavigationState } from 'store/slice/navigation';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface OwnProps {
    isLoading: boolean;
    isDisplayInCitySearchContent: boolean;
    totalFilteredActivities: number;
    isKeywordDisplayed?: boolean;
}

interface StateProps {
    navigation: NavigationState;
    cms: CmsValue;
}

export type SearchTitleProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(selectNavigationState, selectCmsFromBootstrap, (navigation, cms): StateProps => {
    return {
        navigation,
        cms,
    };
});

const SearchTitle: React.FC<SearchTitleProps> = (props) => {
    const location = props.navigation.location;
    const [keyword, setKeyword] = React.useState<string>('');

    React.useEffect(() => {
        location && setKeyword(getKeywordQueryParams(location?.search) || '');
    }, [location]);

    const cmsId = props.totalFilteredActivities <= 1 ? 358219 : 358218;
    const isGlobalKeywordSearch = props.navigation.isGlobalKeywordSearchPage;
    const searchText = isGlobalKeywordSearch && keyword ? `"${keyword}"` : '';

    if (!keyword) {
        return null;
    }

    if (isGlobalKeywordSearch && keyword) {
        return (
            <Feature.On name={FeatureName.GlobalKeywordSearch}>
                {props.isKeywordDisplayed && (
                    <Box data-testid="keyword-title" pb="12" pt="4">
                        <Typography variant="heading-2xl" display="inline" me="12">
                            {searchText}
                        </Typography>
                        {!props.isLoading && (
                            <Typography variant="body-s" textColor="base.subtle" display="inline">
                                {StringFormatter.format(props.cms[cmsId], props.totalFilteredActivities)}
                            </Typography>
                        )}
                    </Box>
                )}
            </Feature.On>
        );
    }

    return <>{props.isDisplayInCitySearchContent && <InCitySearchFilterContent keyword={keyword} />}</>;
};

SearchTitle.displayName = 'SearchTitle';

export default connect(mapStateToProps, mapDispatchToProps)(SearchTitle);
